import { render, staticRenderFns } from "./_information.vue?vue&type=template&id=c50acace"
import script from "./_information.vue?vue&type=script&lang=js"
export * from "./_information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports